import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorization-failed',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
